/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetUserAddress200ResponseAllOfData } from './GetUserAddress200ResponseAllOfData';
import {
    GetUserAddress200ResponseAllOfDataFromJSON,
    GetUserAddress200ResponseAllOfDataFromJSONTyped,
    GetUserAddress200ResponseAllOfDataToJSON,
} from './GetUserAddress200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetUserAddress200Response
 */
export interface GetUserAddress200Response {
    /**
     * 
     * @type {GetUserAddress200ResponseAllOfData}
     * @memberof GetUserAddress200Response
     */
    data: GetUserAddress200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetUserAddress200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetUserAddress200Response interface.
 */
export function instanceOfGetUserAddress200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetUserAddress200ResponseFromJSON(json: any): GetUserAddress200Response {
    return GetUserAddress200ResponseFromJSONTyped(json, false);
}

export function GetUserAddress200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserAddress200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetUserAddress200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetUserAddress200ResponseToJSON(value?: GetUserAddress200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetUserAddress200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

